import type { SelfServeConfigurationFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationMarketingPageQuery';
import type { PageConfig } from 'bundles/unified-description-page-common/types/moduleConfig';
import { ModuleNames } from 'bundles/unified-description-page-common/types/moduleConfig';

const hasCareerOutcomesModule = (pageConfig?: PageConfig | SelfServeConfigurationFragment | null) => {
  if (!pageConfig) return false;
  return !!pageConfig.modules.find((module) => module.name === ModuleNames.CareerOutcomes);
};

export default hasCareerOutcomesModule;
